/* ============================================================
   EARKO — SecureFit Wireless Ear Clips
   No dependencies. Everything below is progressive: the page is
   readable and shoppable with JavaScript disabled.
   ============================================================ */
(function () {
  'use strict';

  /* ==========================================================
     1. PRODUCT CONFIGURATION
     This is the single place to edit price, finishes and where
     the buy buttons go. Nothing else in the codebase hard-codes
     a price, a colour or a checkout destination.
     ========================================================== */
  var PRODUCT = {
    id: 'earko-securefit-01',
    brand: 'EARKO',
    name: 'SecureFit™ Wireless Ear Clips',
    sku: 'EAR-SF-01',

    currency: 'USD',
    locale: 'en-US',
    price: 39.99,

    // Crossed-out comparison price. Leave null unless the store
    // genuinely sells at that price outside of a promotion.
    compareAtPrice: null,      // e.g. 59.99

    // Only true while the retail price actually absorbs shipping.
    freeShipping: true,

    /* ---- PRODUCT IMAGERY ----------------------------------------
       Supplier photographs, cut out to transparent PNG. Every one is
       square and framed identically, so switching finish never shifts
       the layout.

       `image` is deliberately null here. Inside a Shopify theme the
       photographs live in assets/ and are served from the CDN under a
       versioned URL, so the only correct source for them is the
       `asset_url` filter — which layout/theme.liquid runs and hands
       over as window.EARKO_CONFIG.images. Hard-coding a relative path
       here would request a URL that does not exist on the storefront.

       `swatch` is the finish's accent colour — the hook and control
       strip — since that is what actually differs between the four.
       -------------------------------------------------------------- */
    defaultColour: 'black',
    colours: [
      { id: 'black', name: 'Midnight Black', swatch: '#2B2E33', image: null },
      { id: 'white', name: 'Glacier White',  swatch: '#C4C9CF', image: null },
      { id: 'pink',  name: 'Blush Pink',     swatch: '#F0A8BA', image: null },
      { id: 'blue',  name: 'Sky Blue',       swatch: '#BCD9EE', image: null }
    ],

    maxQuantity: 10,

    /* ---- CHECKOUT ------------------------------------------------
       Point the buy buttons at a real destination. Either:

       a) checkoutUrl — any URL. {variant} and {quantity} are
          substituted, so Stripe / PayPal / a custom cart all work:
          'https://buy.stripe.com/xxxx?quantity={quantity}'

       b) shopifyDomain + variants — builds a Shopify cart permalink
          of the form  /cart/<variantId>:<qty>  which lands the buyer
          straight on Shopify checkout.

       Until one is filled in, the buttons say so instead of faking
       a checkout flow.
       -------------------------------------------------------------- */
    checkoutUrl: '',
    shopifyDomain: '',         // e.g. 'earko.myshopify.com'

    /* c) cartUrlBase — what the Shopify layout actually fills in. Usually
       "/cart", or "/fr/cart" on a localised market. The permalink
       <base>/<variantId>:<quantity> replaces the cart and lands the buyer on
       checkout, on this same origin, so the market and currency they were
       browsing in survive the jump. */
    cartUrlBase: '',
    variants: { black: '', white: '', pink: '', blue: '' },

    /* Per-finish stock, keyed the same way as `variants`. Filled in by the
       Shopify layout from variant.available; an absent key means "no
       information", which is treated as available so the fallback build is
       not silently unbuyable. */
    availability: {},

    /* Whether the product resolved at all. The layout sets this to false when
       settings.product_handle matches nothing published to the Online Store
       channel, which is the one failure that makes every price on the page a
       guess — so the page stops offering a checkout instead of guessing. */
    available: true
  };

  /* Reviews from your own verified orders only.
     Do not import from AliExpress, Amazon or another store: the FTC's consumer
     review rule (16 CFR 465) treats a review presented as a buyer's when that
     person did not buy from you — or written for a different seller's listing —
     as a deceptive practice, per violation. The EU Omnibus Directive requires
     you to state how you verify reviews. The empty state below is the honest
     position until real ones exist, and it costs less than a takedown.

     { rating: 5, title: '…', body: '…', author: 'First name',
       verified: true, date: '2026-09-14', colour: 'black',
       photo: '<a CDN URL from Settings → Files>' }             photo optional */
  var REVIEWS = [];

  /* With nothing in REVIEWS the section removes itself instead of showing an
     empty panel. On a store with no order history, "no reviews yet" is a worse
     signal than no review section at all — the space reads as absence rather
     than as a gap waiting to be filled. Flip to true if you would rather run
     the honest empty state while you collect the first ones. */
  var SHOW_EMPTY_REVIEWS = false;


  /* ==========================================================
     HOST OVERRIDES
     A host can inject real data before this file runs — the Shopify theme in
     shopify-theme/ does exactly that, filling in the live price, the variant
     IDs and the CDN asset URLs from Liquid. Everything above stays as the
     fallback, so the same file still works opened straight off disk.
     ========================================================== */
  if (window.EARKO_CONFIG) {
    var CFG = window.EARKO_CONFIG, k;
    if (CFG.product) {
      for (k in CFG.product) {
        if (Object.prototype.hasOwnProperty.call(CFG.product, k)) PRODUCT[k] = CFG.product[k];
      }
    }
    if (CFG.images) {
      PRODUCT.colours.forEach(function (c) {
        if (CFG.images[c.id]) c.image = CFG.images[c.id];
      });
    }
    if (CFG.reviews && CFG.reviews.length) REVIEWS = CFG.reviews;
  }

  /* ========================================================== */

  var root = document.documentElement;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var state = {
    colour: PRODUCT.defaultColour,
    quantity: 1
  };

  var money = function (n) {
    try {
      return new Intl.NumberFormat(PRODUCT.locale, {
        style: 'currency', currency: PRODUCT.currency
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  };

  var colourById = function (id) {
    for (var i = 0; i < PRODUCT.colours.length; i++) {
      if (PRODUCT.colours[i].id === id) return PRODUCT.colours[i];
    }
    return PRODUCT.colours[0];
  };

  /* ---------- 2. PRODUCT IMAGERY ----------
     The hero photo ships in the HTML so the browser starts fetching it
     without waiting for this file. Switching finish swaps every instance,
     cross-fading rather than popping. */

  // The other finishes are ~350 KB each. Fetch them once the browser is idle
  // so they never compete with the hero image for bandwidth on first paint.
  function preloadPhotos() {
    var run = function () {
      PRODUCT.colours.forEach(function (c) {
        if (c.image && c.id !== PRODUCT.defaultColour) {
          var i = new Image();
          i.decoding = 'async';
          i.src = c.image;
        }
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 4000 });
    } else {
      window.addEventListener('load', function () { setTimeout(run, 1200); });
    }
  }

  function paintProduct() {
    var c = colourById(state.colour);
    if (!c.image) return;

    var imgs = $$('.bud').filter(function (img) {
      return img.getAttribute('src') !== c.image;
    });
    if (!imgs.length) return;

    var apply = function () {
      imgs.forEach(function (img) {
        img.src = c.image;
        img.classList.remove('is-swapping');
      });
      var hero = $('.bud');
      if (hero) hero.alt = PRODUCT.name + ' in ' + c.name + ', shown from the front';
    };

    if (reduced) { apply(); return; }

    // Swap only once the fade-out has finished *and* the next photo is
    // decoded. These are ~350 KB each; assigning src directly shows a frame
    // of half-decoded image on the first switch to a colour.
    imgs.forEach(function (img) { img.classList.add('is-swapping'); });

    var pending = 2;
    var ready = function () { if (--pending === 0) apply(); };

    setTimeout(ready, 130);

    var pre = new Image();
    pre.src = c.image;
    if (pre.decode) {
      pre.decode().then(ready, ready);
    } else if (pre.complete) {
      ready();
    } else {
      pre.onload = ready;
      pre.onerror = ready;
    }
  }

  /* ---------- 3. FINISH SELECTOR ---------- */

  function buildSwatches() {
    var wrap = $('[data-swatches]');
    if (!wrap) return;
    PRODUCT.colours.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'swatch';
      b.style.background = c.swatch;
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.name);
      b.setAttribute('data-colour', c.id);
      b.addEventListener('click', function () { setColour(c.id); });
      wrap.appendChild(b);
    });
  }

  function buildFinishList() {
    var wrap = $('[data-finish-list]');
    if (!wrap) return;
    PRODUCT.colours.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'finish__opt';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-colour', c.id);

      /* Built with DOM calls rather than innerHTML. `c.name` and `c.swatch`
         come from PRODUCT.colours, which window.EARKO_CONFIG is allowed to
         overwrite — so a host that ever passed those through from the admin
         would be feeding markup straight into this element. textContent and
         a style property close that off for good rather than relying on the
         values happening to be safe today. */
      var dot = document.createElement('span');
      dot.className = 'finish__dot';
      dot.style.background = c.swatch;

      var text = document.createElement('span');
      var name = document.createElement('b');
      name.textContent = c.name;
      var sub = document.createElement('small');
      sub.textContent = PRODUCT.name;
      text.appendChild(name);
      text.appendChild(sub);

      var tick = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      tick.setAttribute('class', 'tick');
      tick.setAttribute('aria-hidden', 'true');
      var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      use.setAttribute('href', '#i-check');
      tick.appendChild(use);

      b.appendChild(dot);
      b.appendChild(text);
      b.appendChild(tick);
      b.addEventListener('click', function () { setColour(c.id); });
      wrap.appendChild(b);
    });
  }

  function setColour(id) {
    var c = colourById(id);
    state.colour = c.id;

    $$('[data-colour]').forEach(function (el) {
      var on = el.getAttribute('data-colour') === c.id;
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.tabIndex = on ? 0 : -1;
    });
    $$('[data-colour-label]').forEach(function (el) { el.textContent = c.name; });
    paintProduct();
    syncBuyState();
  }

  /* Arrow-key navigation inside each radiogroup */
  function wireRadioKeys(group) {
    if (!group) return;
    group.addEventListener('keydown', function (e) {
      var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'];
      if (keys.indexOf(e.key) === -1) return;
      e.preventDefault();
      var ids = PRODUCT.colours.map(function (c) { return c.id; });
      var i = ids.indexOf(state.colour);
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var next = ids[(i + step + ids.length) % ids.length];
      setColour(next);
      var el = group.querySelector('[data-colour="' + next + '"]');
      if (el) el.focus();
    });
  }

  /* ---------- 4. PRICE + QUANTITY ---------- */

  function renderPrice() {
    /* When the layout could not resolve the product, PRODUCT.price is still the
       placeholder this file ships with. Painting it would put a number on the
       page that no longer comes from Shopify — the one thing a storefront must
       never do. Show an em dash and say why in the console instead. */
    if (PRODUCT.resolved === false) {
      $$('[data-price-unit], [data-price-total]').forEach(function (el) {
        el.textContent = '—';
      });
      $$('[data-compare]').forEach(function (el) { el.hidden = true; });
      return;
    }

    $$('[data-price-unit]').forEach(function (el) { el.textContent = money(PRODUCT.price); });
    $$('[data-price-total]').forEach(function (el) {
      el.textContent = money(PRODUCT.price * state.quantity);
    });
    $$('[data-compare]').forEach(function (el) {
      if (PRODUCT.compareAtPrice && PRODUCT.compareAtPrice > PRODUCT.price) {
        el.textContent = money(PRODUCT.compareAtPrice);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
    $$('[data-shipping]').forEach(function (el) {
      el.textContent = PRODUCT.freeShipping ? 'Free shipping' : 'Shipping calculated at checkout';
    });
  }

  function setQuantity(n) {
    state.quantity = Math.min(PRODUCT.maxQuantity, Math.max(1, n));
    $$('[data-qty-value]').forEach(function (el) { el.textContent = state.quantity; });
    $$('[data-qty]').forEach(function (b) {
      var d = parseInt(b.getAttribute('data-qty'), 10);
      b.disabled = (d < 0 && state.quantity === 1) ||
                   (d > 0 && state.quantity === PRODUCT.maxQuantity);
    });
    renderPrice();
    syncBuyState();
  }

  /* ---------- 5. CHECKOUT ---------- */

  // <base>/<variantId>:<quantity> — Shopify's cart permalink. Trailing slashes
  // are stripped so "/" and "/cart" both produce a single separator.
  function cartPermalink(variantId, quantity) {
    return String(PRODUCT.cartUrlBase).replace(/\/+$/, '') +
           '/' + encodeURIComponent(variantId) + ':' + String(quantity);
  }

  var toastTimer;
  function notify(html) {
    var t = $('#toast');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-up');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-up'); }, 6000);
  }

  function startCheckout(e) {
    if (e) e.preventDefault();

    var line = {
      productId: PRODUCT.id,
      sku: PRODUCT.sku,
      name: PRODUCT.name,
      colour: state.colour,
      colourName: colourById(state.colour).name,
      quantity: state.quantity,
      unitPrice: PRODUCT.price,
      total: +(PRODUCT.price * state.quantity).toFixed(2),
      currency: PRODUCT.currency,
      variantId: PRODUCT.variants[state.colour] || null
    };

    // Analytics and third-party carts can listen for this.
    document.dispatchEvent(new CustomEvent('earko:checkout', { detail: line }));

    if (PRODUCT.cartUrlBase && line.variantId) {
      window.location.href = cartPermalink(line.variantId, line.quantity);
      return;
    }

    // A checkout URL that interpolates the variant is useless without one.
    // Fall through rather than sending the buyer to /cart/:1, which is a 404.
    if (PRODUCT.checkoutUrl &&
        (PRODUCT.checkoutUrl.indexOf('{variant}') === -1 || line.variantId)) {
      window.location.href = PRODUCT.checkoutUrl
        .replace('{variant}', encodeURIComponent(line.variantId || ''))
        .replace('{quantity}', String(line.quantity))
        .replace('{colour}', encodeURIComponent(line.colour));
      return;
    }

    if (PRODUCT.shopifyDomain && line.variantId) {
      window.location.href = 'https://' + PRODUCT.shopifyDomain +
        '/cart/' + line.variantId + ':' + line.quantity;
      return;
    }

    notify('This finish is not available to order right now. Please try another ' +
           'finish, or email us and we will let you know when it is back.');
    if (window.console) {
      console.warn('[EARKO] no variant to check out with', line,
                   'Publish the product to the Online Store sales channel and ' +
                   'confirm Theme settings → Product handle.');
    }
  }

  /* The buy buttons reflect what Shopify says can actually be sold. A finish
     with no variant ID, or one Shopify reports as out of stock, disables the
     button instead of leaving a control that looks live and does nothing. */
  function syncBuyState() {
    var ok = PRODUCT.resolved !== false &&
             PRODUCT.available !== false &&
             !!PRODUCT.variants[state.colour] &&
             PRODUCT.availability[state.colour] !== false;

    // Only state is touched here, never the label markup: the dock button's
    // label contains the live total in a <span data-price-total>, and
    // rewriting textContent would delete it.
    $$('[data-checkout]').forEach(function (el) {
      if (el.tagName === 'BUTTON') el.disabled = !ok;
      el.setAttribute('aria-disabled', ok ? 'false' : 'true');
      el.classList.toggle('is-unavailable', !ok);

      // Keep the no-JavaScript href honest as the finish and quantity change,
      // so a middle-click or a copied link buys what is on screen.
      if (el.tagName === 'A' && ok && PRODUCT.cartUrlBase) {
        el.setAttribute('href',
          cartPermalink(PRODUCT.variants[state.colour], state.quantity));
      }
    });
  }

  /* ---------- 6. REVIEWS ---------- */

  function starsMarkup(rating) {
    var s = '';
    for (var i = 0; i < 5; i++) {
      s += '<svg aria-hidden="true" style="opacity:' + (i < rating ? 1 : 0.22) +
           '"><use href="#i-star"></use></svg>';
    }
    return s;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderReviews() {
    var host = $('[data-reviews]');
    if (!host) return;
    var summary = $('[data-review-summary]');

    var section = document.getElementById('reviews');

    if (!REVIEWS.length) {
      if (!SHOW_EMPTY_REVIEWS) {
        if (section) section.hidden = true;
        return;
      }
      host.innerHTML =
        '<div class="reviews__empty">' +
          '<svg aria-hidden="true"><use href="#i-chat"></use></svg>' +
          '<h3>No reviews yet</h3>' +
          '<p>This space is reserved for people who actually bought from us. It fills in ' +
          'once the first orders land &mdash; photos included, if buyers send them.</p>' +
        '</div>';
      if (summary) summary.innerHTML = '';
      return;
    }

    if (section) section.hidden = false;

    /* Normalise before anything is built. `rating` used to go straight into an
       aria-label with no escaping, so a review whose rating was a string
       containing a double quote broke out of the attribute and could add an
       event handler to the element. Coercing to a bounded integer fixes the
       class of bug rather than one instance of it, and also stops a stray
       string turning the average into NaN. */
    var list = REVIEWS.map(function (r) {
      var c = {}, k;
      for (k in r) { if (Object.prototype.hasOwnProperty.call(r, k)) c[k] = r[k]; }
      c.rating = Math.max(0, Math.min(5, parseInt(r.rating, 10) || 0));
      return c;
    });

    var total = list.reduce(function (n, r) { return n + r.rating; }, 0);
    var avg = total / list.length;

    if (summary) {
      summary.innerHTML =
        '<div class="reviews__summary">' +
          '<b class="reviews__avg num">' + avg.toFixed(1) + '</b>' +
          '<div class="reviews__meta">' +
            '<div class="review__stars" role="img" aria-label="' + avg.toFixed(1) +
              ' out of 5">' + starsMarkup(Math.round(avg)) + '</div>' +
            '<span>' + list.length + (list.length === 1 ? ' review' : ' reviews') +
              ' from verified orders</span>' +
          '</div>' +
        '</div>';
    }

    var grid = document.createElement('div');
    grid.className = 'reviews__grid';

    list.forEach(function (r) {
      var el = document.createElement('article');
      el.className = 'review glass';
      var bits = '';

      if (r.photo) {
        bits += '<img class="review__photo" src="' + esc(r.photo) + '" loading="lazy" ' +
                'decoding="async" alt="Photo from ' + esc(r.author) + '">';
      }
      bits += '<div class="review__stars" role="img" aria-label="' + r.rating +
              ' out of 5">' + starsMarkup(r.rating) + '</div>';
      if (r.title) bits += '<h3>' + esc(r.title) + '</h3>';
      bits += '<p>' + esc(r.body) + '</p>';

      var meta = [esc(r.author)];
      if (r.colour) meta.push(esc(colourById(r.colour).name));
      if (r.date) meta.push(esc(r.date));
      bits += '<footer>' +
        (r.verified ? '<span class="review__tag"><svg aria-hidden="true">' +
          '<use href="#i-check"></use></svg>Verified order</span><br>' : '') +
        meta.join(' &middot; ') + '</footer>';

      el.innerHTML = bits;
      grid.appendChild(el);
    });

    host.innerHTML = '';
    host.appendChild(grid);
  }

  /* ---------- 7. NAVIGATION ---------- */

  function wireNav() {
    var nav = $('#nav');
    var burger = $('#burger');
    if (burger && nav) {
      var burgerLabel = $('[data-burger-label]');
      var setMenuState = function (open) {
        nav.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        // The visible word is the state indicator; aria-expanded already tells
        // assistive tech, so the label itself needs no extra announcement.
        if (burgerLabel) burgerLabel.textContent = open ? 'Close' : 'Menu';
      };
      burger.addEventListener('click', function () {
        setMenuState(!nav.classList.contains('is-open'));
      });
      // Escape closes it, which a menu that covers the page needs.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
          setMenuState(false);
          burger.focus();
        }
      });
      $$('#drawer a').forEach(function (a) {
        a.addEventListener('click', function () { setMenuState(false); });
      });
    }
    var onScroll = function () {
      if (nav) nav.classList.toggle('is-stuck', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- 8. SCROLL REVEAL ---------- */

  function wireReveal() {
    var items = $$('.reveal');
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 9. STICKY DOCK ---------- */

  function wireDock() {
    var dock = $('#dock');
    // Track the hero buy button itself, not the whole card: the dock should
    // take over the moment the real CTA leaves the screen, which on a phone
    // is already true at first paint.
    var anchor = $('#buyCard .btn') || $('#buyCard');
    if (!dock || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      dock.classList.toggle('is-up', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- 10. PARALLAX + TILT ---------- */

  function wireMotion() {
    if (reduced) return;

    // Scroll parallax — the product drifts slightly against the page.
    var targets = [];
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = targets.indexOf(en.target);
        if (en.isIntersecting && i === -1) targets.push(en.target);
        if (!en.isIntersecting && i > -1) targets.splice(i, 1);
      });
    }, { rootMargin: '20% 0px' });
    $$('[data-parallax]').forEach(function (el) { pio.observe(el); });

    var ticking = false;
    var update = function () {
      var vh = window.innerHeight;
      targets.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var mid = r.top + r.height / 2;
        var off = (mid - vh / 2) / vh;            // -1 .. 1
        el.style.setProperty('--py', (off * -22).toFixed(2) + 'px');
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();

    // Pointer tilt — every product on the page, fine pointers only.
    // This writes nothing but two numbers; the rotation itself is CSS.
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    $$('.stage').forEach(function (stage) {
      var tilt = stage.querySelector('.bud-tilt');
      if (!tilt) return;

      var mx = 0, my = 0, frame = 0;
      var write = function () {
        frame = 0;
        tilt.style.setProperty('--mx', mx.toFixed(3));
        tilt.style.setProperty('--my', my.toFixed(3));
      };

      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;   // -0.5 … 0.5
        my = (e.clientY - r.top) / r.height - 0.5;
        if (!frame) frame = requestAnimationFrame(write);
      });

      stage.addEventListener('pointerleave', function () {
        mx = my = 0;
        if (!frame) frame = requestAnimationFrame(write);
      });
    });
  }

  /* ---------- 11. GLASS TREATMENT ---------- */

  function applyGlass() {
    if (!window.GlassIcons) return;
    var palette = ['azure', 'sky', 'deep', 'navy'];

    // Icons that already sit beside copy become tiles: same plates, same
    // motion, caption left where it is.
    $$('.gi-slot').forEach(function (slot, i) {
      var tile = GlassIcons.tile(slot.getAttribute('data-gi'), palette[i % palette.length]);
      slot.parentNode.replaceChild(tile, slot);
    });

    // Text buttons keep their label and gain the plates behind it.
    GlassIcons.enhanceButtons('.btn');

    // Quantity steppers are icon-only, so they take the component as designed.
    $$('.qty [data-qty]').forEach(function (b) {
      var sign = b.textContent.trim();
      b.classList.add('icon-btn', 'icon-btn--ctl');
      b.textContent = '';
      var back = document.createElement('span');
      back.className = 'icon-btn__back';
      back.style.background = GlassIcons.gradients.azure;
      var front = document.createElement('span');
      front.className = 'icon-btn__front';
      var ico = document.createElement('span');
      ico.className = 'icon-btn__icon';
      ico.setAttribute('aria-hidden', 'true');
      ico.textContent = sign;
      front.appendChild(ico);
      b.appendChild(back);
      b.appendChild(front);
    });

    var burger = $('#burger');
    var burgerBox = $('[data-burger-box]');
    if (burger && burgerBox && !burger.classList.contains('is-glass')) {
      // Into the box, not the button — the button also holds the text label,
      // and the plates must not cover it. Colour is left to CSS so the open
      // state can repaint the plate without JavaScript.
      var bBack = document.createElement('span');
      bBack.className = 'icon-btn__back';
      var bFront = document.createElement('span');
      bFront.className = 'icon-btn__front';
      burgerBox.insertBefore(bFront, burgerBox.firstChild);
      burgerBox.insertBefore(bBack, burgerBox.firstChild);
      burger.classList.add('is-glass');
    }
  }

  /* ---------- 12. BOOT ---------- */

  function init() {
    if (PRODUCT.resolved === false && window.console) {
      console.warn('[EARKO] No product matched the handle "' + PRODUCT.unresolvedHandle +
        '". Prices and the buy button are disabled until it resolves. Check that ' +
        'the handle in Theme settings → Product matches the product URL, and that ' +
        'the product is published to the Online Store sales channel.');
    }
    applyGlass();
    preloadPhotos();
    buildSwatches();
    buildFinishList();
    setColour(PRODUCT.defaultColour);
    wireRadioKeys($('[data-swatches]'));
    wireRadioKeys($('[data-finish-list]'));

    setQuantity(1);
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        setQuantity(state.quantity + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    $$('[data-checkout]').forEach(function (b) {
      b.addEventListener('click', startCheckout);
    });

    renderPrice();
    renderReviews();
    wireNav();
    wireReveal();
    wireDock();
    wireMotion();

    $$('[data-year]').forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  // Exposed for a future cart or analytics layer.
  window.EARKO = { product: PRODUCT, state: state, checkout: startCheckout, setColour: setColour };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
